module.exports = __webpack_public_path__ + "img/1578469041.12a6d1d3.jpg";